/* @flow */

'use strict';

var getStateKey = function getStateKey(elementKey /*: ?string*/) /*: string*/ {
  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
};

module.exports = getStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/get-state-key.js
// module id = 717
// module chunks = 0